var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header",style:({ backgroundColor: '#' + _vm.retailerColor || 'var(--primary)' })},[_c('div',{class:_vm.hasContainer ? 'isContainer' : ''},[_c('Asset',{attrs:{"name":_vm.retailerLogo || 'logo-white.svg',"alt":"Logo","title":"Logo","version":null}})],1)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }